<div class="video_card_wrapper" (mouseenter)="hoverOn()" (mouseleave)="hoverOff()">

    <div *ngIf="!video.open" [ngClass]="adding||hover||refreshing?'tooltip-visible':'tooltip-hidden'"
        class="blocked-video-tooltip">
        <p *ngIf="!refreshing&&!adding" class="blocked-video-message">סרטון זה אינו ברשימת הסרטונים שלך.
            <button class="blocked-video-link .text" target="_blank" (click)="addSite()">לחץ כאן כדי להוסיף את הסרטון
            </button>
        </p>

        <p *ngIf="refreshing">
            מרענן הגדרות...

        </p>

        <p *ngIf="adding">
            מוסיף עבורך את הסרטון...
        </p>

    </div>

    <div>
        <a [routerLink]="video.open ?'../video':null" [queryParams]="{ videoId: video.videoId}">

            <img class="card_video"
                [srcset]="'https://i.ytimg.com/vi/'+video.videoId+'/mqdefault.jpg'+' , https://i.ytimg.com/vi/'+video.videoId+'/sddefault.jpg'"
                [alt]="video.title" loading="lazy" />
        </a>
        <div class="card_details">
            <a [routerLink]="video.open ?'../video':null" [queryParams]="{ videoId: video.videoId}">

                <h2 class="card_title">{{video.title}}</h2>
            </a>

            <div class="card_details_line">
                <h3>{{video.channelTitle}}</h3>
                <img *ngIf="url==='/favorites'" (click)="removeFromFavorite()" class="icon"
                    src="assets/images/herat-i.png" />
                <svg *ngIf="!video.open" class="blocked-video-icon icon" viewBox="0 0 300 300" fill="none">
                    <circle cx="150" cy="150" r="100" fill="none" stroke="red" stroke-width="40" />
                    <path d="M80 70 L220 230" fill="none" stroke="red" stroke-width="40" />
                </svg>
                <!-- <img  src="assets/images/block.png"/> -->
            </div>

        </div>
    </div>
</div>